<div class="chatbot-agent-area" [class.chatbot-agent-area--android]="isAndroidPlatform">
  <div class="agent-visual" [class.agent-visual--hidden]="captionWords.length > 0 && !captionLeaving">
    <app-hal-realtime
      [cif]="cif"
      [currentSessionId]="currentSessionId"
      [currentUserName]="currentUserName"
      (captionChange)="onAgentCaption($event)">
    </app-hal-realtime>
  </div>

  <div class="agent-caption" #captionBox
    *ngIf="captionWords.length"
    [class.agent-caption--leaving]="captionLeaving"
    [class.agent-caption--overflowing]="captionOverflowing"
    aria-live="polite">
    <p class="agent-caption__text" #captionText><ng-container *ngFor="let word of captionWords; trackBy: trackByIndex"><span class="agent-caption__word">{{ word }}</span>{{ ' ' }}</ng-container></p>
  </div>

  <p class="agent-status-text" *ngIf="isMuted$ | async">Microphone muted</p>

  <div class="agent-action-wrapper">
    <button
      type="button"
      class="agent-btn"
      [class.agent-btn--muted]="isMuted$ | async"
      [attr.aria-pressed]="isMuted$ | async"
      (click)="toggleMicrophoneMute()"
      aria-label="Toggle microphone">
      <img src="assets/img/ai-chat/voice-mic.svg" width="26" height="26" alt="" />
    </button>

    <button type="button" class="agent-btn" (click)="closeConversationalAgent()" aria-label="Return to text chat">
      <img src="assets/img/ai-chat/voice-chat.svg" width="24.2951" height="26" alt="" />
    </button>
  </div>
</div>
